import { render } from "./CollectionFolderDisplay.vue?vue&type=template&id=37e55e2b&scoped=true"
import script from "./CollectionFolderDisplay.vue?vue&type=script&lang=js"
export * from "./CollectionFolderDisplay.vue?vue&type=script&lang=js"

import "./CollectionFolderDisplay.vue?vue&type=style&index=0&id=37e55e2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e55e2b"]])

export default __exports__